module.exports = require("../../version/Copyright.vue");